import { Route } from 'react-router';

import { RECALLS_BASE_ROUTE } from 'pages/recalls/base-path';

export function getRecallsRoutes(hasRecallsV2: boolean) {
  console.log(`[Recalls] Using ${hasRecallsV2 ? 'V2' : 'V1'} routes`);

  if (hasRecallsV2) {
    return (
      <Route path={RECALLS_BASE_ROUTE} lazy={() => import('routes/recalls/recalls.route')}>
        <Route index lazy={() => import('routes/recalls/recalls-index.route')} />
        <Route id="recall-id" path=":recallId" lazy={() => import('routes/recalls/recall-detail/recall-detail.route')}>
          <Route index lazy={() => import('routes/recalls/recall-detail/recall-detail-index.route')} />
          <Route
            path="affected-items"
            lazy={() => import('routes/recalls/recall-detail-affected-items/recall-detail-affected-items.route')}
          />
          <Route path="emails" lazy={() => import('routes/recalls/recall-detail-emails/recall-detail-emails.route')} />
          <Route path="tasks" lazy={() => import('routes/recalls/recall-detail-tasks/recall-detail-tasks.route')} />
        </Route>
      </Route>
    );
  }

  /* Old Recalls Routes */
  return (
    <Route path={RECALLS_BASE_ROUTE} lazy={() => import('pages/recalls/routes/recalls')}>
      <Route index lazy={() => import('pages/recalls/routes/recalls.index')} />
      <Route id="recall-id" path=":recallId" lazy={() => import('pages/recalls/routes/recalls.$recallId')}>
        <Route index lazy={() => import('pages/recalls/routes/recalls.$recallId.index')} />
        <Route path="affected-items" lazy={() => import('pages/recalls/routes/recalls.$recallId.affected-items')} />
        <Route path="tasks" lazy={() => import('pages/recalls/routes/recalls.$recallId.tasks')} />
      </Route>
    </Route>
  );
}
